export const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { duration: 1.0, ease: "easeOut" },
  },
};

export const slideLeft = {
  hidden: { opacity: 0, x: -40 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};

export const slideRight = {
  hidden: { opacity: 0, x: 40 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};

export const mobileMenuVariants = {
  hidden: {
    height: 0,
    opacity: 0,
  },
  show: {
    height: "calc(100vh - 80px)",
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.77, 0, 0.18, 1],
    },
  },
  exit: {
    height: 0,
    opacity: 0,
    transition: {
      duration: 0.4,
      ease: [0.77, 0, 0.18, 1],
    },
  },
};

export const slideUp = {
  hidden: {
    opacity: 0,
    y: 60,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

export const slideRightCard = {
  hidden: {
    opacity: 0,
    x: 60,
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

export const variants = {
  primary: `
    bg-gradient-to-r from-neonYellow to-neonYellow
    text-white
    shadow-[0_8px_25px_rgba(139,0,0,0.25)]
    hover:shadow-[0_12px_35px_rgba(139,0,0,0.35)]
    hover:bg-gradient-to-r from-neonYellow to-neonYellow
  `,
  outline: `
    border-0 hover:border-1 border-navy
    bg-none
    text-navy
    hover:bg-amber
    hover:text-navy
  `,
};

export const pageContainerVariants = {
  hidden: {
    opacity: 0,
  },

  show: {
    opacity: 1,

    transition: {
      staggerChildren: 0.14,
    },
  },
};

export const fadeUpVariants = {
  hidden: {
    opacity: 0,
    y: 30,
  },

  show: {
    opacity: 1,
    y: 0,

    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

export const cardVariants = {
  hidden: {
    opacity: 0,
    y: 40,
    scale: 0.97,
  },

  show: {
    opacity: 1,
    y: 0,
    scale: 1,

    transition: {
      duration: 0.55,
      ease: "easeOut",
    },
  },
};

export const backdropVariants = {
  hidden: {
    opacity: 0,
  },

  show: {
    opacity: 1,

    transition: {
      duration: 0.2,
    },
  },

  exit: {
    opacity: 0,

    transition: {
      duration: 0.2,
    },
  },
};

export const modalVariants = {
  hidden: {
    opacity: 0,
    y: 35,
    scale: 0.94,
  },

  show: {
    opacity: 1,
    y: 0,
    scale: 1,

    transition: {
      type: "spring",
      stiffness: 280,
      damping: 25,
    },
  },

  exit: {
    opacity: 0,
    y: 25,
    scale: 0.96,

    transition: {
      duration: 0.18,
    },
  },
};
